import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import {PeticionC} from "../../../listado-peticiones/listado-peticiones.component";
import {ComentarioContact} from "../../../GestionPeticiones/detalle-peticion/detalle-peticion.component";

@Injectable({
  providedIn: 'root'
})
export class GestionesVariasService
{
  constructor(private http: HttpClient,private msalService:MsalService){}

  public gestionIdRlsHoja(token:string,usuario:string, empresa:number, hoja:number,id:number, agente:number, idIncid: number){
    let url: string = environment.rlsWSBase + "/ServCorredor/gestionIdRls";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
      {
        "usuario": usuario,
        "empresa": empresa,
        "hoja": hoja,
        "id": id,
        "agente": agente,
        "idincid": idIncid
      }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }
  public getCorredor(token:string,cia:string, id:number, fInicio:string,fFin:string, estado:number, matricula: string){
    let url: string = environment.rlsWSBase + "/ServCorredor";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
      {
        parameters:
          [
            [{
              campo:"fecha",
              operacion:">=",
              valor:fInicio
            }],
            [{
              campo:"fecha",
              operacion:"<=",
              valor:fFin
            }],
            [{
              campo:"id",
              operacion:">",
              valor:"0"
            }],
            [
              {
                campo:"agente",
                operacion:"<",
                valor:"206000"
              },
              {
                campo:"agente",
                operacion:">",
                valor:"206999"
              }
            ]
          ],
        select: ["id","fecha", "agente as cliente","par1 as estado","asegurado as titular","cia", "COALESCE(matricula,'') as matricula", "agent_sub as sub_del"],
        orden: [["fecha","ASC"], ["hora", "asc"]]
      };
    if(estado < 5 )
    {
      arrParams.parameters
        .push
        (
          [{
            campo:"par1",
            operacion:"=",
            valor:estado+""
          }]
        )
    }
    if (!isNaN(id)){
      arrParams.parameters
        .push
        (
          [{
            campo:"id",
            operacion:"=",
            valor:id+""
          }]
        )
    }
    if (matricula !== ""){
      arrParams.parameters
        .push
        (
          [{
            campo:"matricula",
            operacion:"=",
            valor:matricula.toUpperCase()+""
          }]
        )
    }
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }
  public getListado(token:string,cia:string, id:number, fInicio:string,fFin:string, estado:number, matricula: string):Promise<PeticionC[]>
  {
    let url: string = "";
    let select: string[] = [];
    let op1: string[] = ["id","fecha", "agente as cliente","par1 as estado","asegurado as titular","cia", "matricula", "agent_sub as sub_del"];
    let op2: string[] = ["pet as id", "fecha", "cliente","titular", "cia","matricula","par_001 as estado"];
    let filtros: any;
    let nom_camp : string = "par1";
    let orden: any;
    let id_pet: string = "id";
    switch (cia){
      case "TUVOZ":
        url = environment.callCenterWSBase + "/Coris";
        nom_camp = "par_001";
        filtros =
          [{
            campo:"cliente",
            operacion:"=",
            valor:"TUVOZ"
          }];
        select = op2;
        orden = [["created", "ASC"]];
        id_pet = "pet";
        break;
      case "REPARABRISAS RLS":
        url = environment.rlsWSBase + "/ServCorredor";
        select = op1;
        filtros = [
          [{
            campo:"agente",
            operacion:">=",
            valor:"206000"
          }],
          [{
            campo:"agente",
            operacion:"<=",
            valor:"206999"
          }]
        ];
        orden = [["fecha","ASC"], ["hora", "asc"]];
        break;
      case "COLABORADORES RLS":
        url = environment.rlsWSBase + "/ServCorredor";
        select = op1;
        filtros = [
          [{
            campo:"agente",
            operacion:">=",
            valor:"300000"
          }],
          [{
            campo:"agente",
            operacion:"<=",
            valor:"305000"
          }]
        ];
        orden = [["fecha","ASC"], ["hora", "asc"]];
        break;
    }

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
      .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
    {
      parameters:
      [
        [{
          campo:"fecha",
          operacion:">=",
          valor:fInicio
        }],
        [{
          campo:"fecha",
          operacion:"<=",
          valor:fFin
        }],
        [{
          campo:id_pet,
          operacion:">",
          valor:"0"
        }]
      ],
      select: select,
      orden: orden
    };
    if(estado < 5 )
    {
      arrParams.parameters
      .push
      (
        [{
          campo:nom_camp,
          operacion:"=",
          valor:estado+""
        }]
      )
    }
    if (!isNaN(id)){
      arrParams.parameters
        .push
        (
          [{
            campo:id_pet,
            operacion:"=",
            valor:id+""
          }]
        )
    }
    if (matricula !== ""){
      arrParams.parameters
        .push
        (
          [{
            campo:"matricula",
            operacion:"=",
            valor:matricula.toUpperCase()+""
          }]
        )
    }
    if (filtros !== null){
      if (filtros.length > 1){
        arrParams.parameters
          .push
          (
            filtros[0]
          );
        arrParams.parameters
          .push
          (
            filtros[1]
          );
      }else {
        arrParams.parameters
          .push
          (
            filtros
          );
      }
    }
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
      .subscribe
      ({
        next(res)
        {
          resolve(res);
        },
        error(err)
        {
          reject(err);
        },
      })
    });
  }
  public getForId(token:string, id:number){
    let url:string =  environment.rlsWSBase + "/ServCorredor";

    const httpOptions = {
      headers: new HttpHeaders
      ({
        'Content-Type': 'application/json',
      })
        .set('Authorization', 'Bearer ' + token ),

      params: new HttpParams({})
    };
    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"id",
              operacion:"=",
              valor:id
            }]
          ]
      };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        })
    });
  }
  public getLineasComentario(token:string, id:string):Promise<ComentarioContact[]>
  {
    let url:string = environment.rlsWSBase + "/ServCorredorLin/"

    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
        .set('Authorization', 'Bearer ' + token ),
      params: new HttpParams({})
    };
    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"id",
              operacion:"=",
              valor:id+""
            }]
          ],
        select:
          [
            "linea",
            "obser",
            "usuario",
            "to_char(created, 'DD/MM/YYYY HH24:mi') as created"
          ],
        orden: [["linea","DESC"]]
      };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            reject(err);
          },
        });
    });
  }

  public UpdateEstadoWeb(token: string, param: any){
    let url:string = environment.rlsWSBase + "/ServCorredor/update";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,param,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public getSubAgente(token: string, agent: string, subagent: string){
    let url:string = environment.rlsWSBase + "/AgentsSub/";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }
    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"agent",
              operacion:"=",
              valor:agent+""
            }],
            [{
              campo:"agent_sub",
              operacion:"=",
              valor:subagent+""
            }]
          ],
        select:
          [
            "nom",
            "delegacion"
          ]
      };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public getAgente(token: string, agent: string){
    let url:string = environment.rlsWSBase + "/Agents/";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Headers', 'Content-Type');
    options = options.set('Authorization', 'Bearer ' + token);

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }
    let arrParams =
      {
        "parameters":
          [
            [{
              campo:"agent",
              operacion:"=",
              valor:agent+""
            }]
          ]
      };
    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,arrParams,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}
